import { Checkbox, FormControlLabel, SxProps, Typography } from "@mui/material";
import React from "react";

interface ImportGuestOrderingCheckboxProps {
  checked: boolean;
  onChange: (value: boolean) => void;
  sx?: SxProps;
}

export const ImportGuestOrderingCheckbox = ({ checked, onChange, sx }: ImportGuestOrderingCheckboxProps) => {
  return (
    <FormControlLabel
      label={<Typography variant="body2">Enable Guest Ordering</Typography>}
      control={<Checkbox checked={checked} onChange={e => onChange(e.target.checked)} sx={sx} />}
    />
  );
};
